
import { Component, Input, OnInit, inject } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { ErrorMessagesPipe } from '../pipes/error-messages.pipe';

@Component({
    selector: 'cerrix-color-picker',
    imports: [
    ErrorMessagesPipe,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule
],
    templateUrl: './cerrix-color-picker.component.html',
    styleUrl: './cerrix-color-picker.component.scss',
    providers: []
})
export class CerrixColorPickerComponent
  implements OnInit, ControlValueAccessor
{
  private defaultColor: string = '#000000';
  protected predefinedColors: string[] = [
    '#000000',
    '#66c664',
    '#b72121',
    '#ff0000',
    '#f39a14',
    '#0c66e4',
    '#17c1a1',
    '#5b3bb7',
    '#d9d9d9',
    '#33b6d3',
  ];

  private _value: string = this.defaultColor;
  @Input()
  set value(value: string) {
    if (this._value === value) {
      return;
    }

    this._value = value?.toLowerCase();

    this.updateColorText();
  }
  get value() {
    return this._value;
  }

  @Input() public disabled: boolean = false;
  @Input() public dataUiid: string = "undefined"

  protected colorTextForm = new FormControl<string>({
    value: this.value?.replace('#', ''),
    disabled: this.disabled,
  });

  private updateColorText() {
    this.colorTextForm.patchValue(this.value?.replace('#', ''), {
      emitEvent: true,
    });
  }

  protected ngControl = inject(NgControl, { optional: true, self: true });

  private onValueChange = (value: string) => {};
  private onTouched = () => {};

  public writeValue(value: string): void {
    this.value = value;
  }
  public registerOnChange(onChange: (value: string) => void): void {
    this.onValueChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (this.disabled) {
      this.colorTextForm.disable();
    } else {
      this.colorTextForm.enable();
    }
  }

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    if (this.disabled) {
      this.colorTextForm.disable();
    } else {
      this.colorTextForm.enable();
    }
  }

  protected onChange(event: Event) {
    this.value = (event.target as HTMLInputElement)?.value;
    this.onValueChange(this.value);
    this.updateColorText();
  }

  protected onPredefinedSelection(color: string) {
    if (!this.disabled) {
      this.value = color;
      this.onValueChange(this.value);
      this.updateColorText();
    }
  }

  protected onColorTextChange(event: Event) {
    let newColor = (event.target as HTMLInputElement)?.value ?? '';
    newColor = newColor.replace(/[^a-fA-F0-9\s]/gi, '').toLowerCase();
    if (newColor.length > 6) {
      newColor = newColor.substring(0, 6);
    }

    if (newColor.length === 6) {
      this.value = '#' + newColor;
      this.onValueChange(this.value);
      this.updateColorText();
    } else {
      this.colorTextForm.patchValue(newColor, {
        emitEvent: true,
      });
    }
  }
}
